var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.374,
    height: 19.856,
    viewBox: "0 0 17.374 19.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-share-alt",
    "data-name": "Icon awesome-share-alt",
    d: "M13.651,12.41a3.707,3.707,0,0,0-2.319.81L7.358,10.736a3.744,3.744,0,0,0,0-1.617l3.975-2.484a3.716,3.716,0,1,0-1.316-2.1L6.042,7.015a3.723,3.723,0,1,0,0,5.825l3.975,2.484a3.723,3.723,0,1,0,3.635-2.915Z",
    fill: "#090909",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2f32cecc2e954518d969b1c8ea98d08f.svg";
export { ForwardRef as ReactComponent };